module.exports = __webpack_public_path__ + "img/user.7daf4aa9.png";